import dayjs, { Dayjs } from "dayjs";
import { StateSlice } from "./app";

export type DataProps = {
  selectedDate: Dayjs;
};

export type DataState = DataProps & {
  setSelectedDate: (selectedDate: Dayjs) => void;
};

export const createDataState: StateSlice<DataState> = (set) => ({
  selectedDate: dayjs(),
  setSelectedDate: (selectedDate: Dayjs) =>
    set({ selectedDate }, false, {
      type: "setSelectedDate",
      selectedDate,
    }),
});
